// Module
var code = "<div class=\"tmr-backdrop\" ng-click=\"$ctrl.onClose()\"></div> <div class=\"workstation-error-box is-bold\" layout layout-padding> <md-icon class=\"o-important-warning-1 tmr-icon-32\"></md-icon> <p translate>WORKSTATIONSELECT.NONE</p> </div> ";
// Exports
var _module_exports =code;;
var path = 'routes/errors/workstationError/workstationError.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;